import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

import type { SelectProps } from '@mui/material/Select';

interface CommonCementProps {
  value: boolean;
  onChange: (value: boolean) => void;
  slotProps?: SelectProps['slotProps'];
  error?: boolean;
  helperText?: string;
}

/**
 * Common component for セメント共通 (Common Cement) selection
 * Used in supplier and witness company forms
 */
export const CommonCement: React.FC<CommonCementProps> = ({
  value,
  slotProps,
  onChange,
  error = false,
  helperText,
}) => {
  return (
    <Box>
      <FormControl fullWidth error={error}>
        <InputLabel>セメント共通</InputLabel>
        <Select
          value={value ? 'true' : 'false'}
          onChange={(e) => onChange(e.target.value === 'true')}
          label='セメント共通'
          slotProps={slotProps}
        >
          <MenuItem value='true'>対象</MenuItem>
          <MenuItem value='false'>対象外</MenuItem>
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
};
